import React from 'react'
import { Outlet } from 'react-router-dom'

const Boards = () => {
  return (
    <>
     <Outlet/>
    </>
  )
}

export default Boards